export type OptionalViewModel<T> = {
  present: boolean;
  value: T;
};

export function optionalFieldToViewModel<T>(
  field: T | undefined,
  defaultValue: T
): OptionalViewModel<T> {
  if (field !== undefined) {
    return { present: true, value: field };
  } else {
    return { present: false, value: defaultValue };
  }
}

export function optionalViewModelToField<T>(
  viewModel: OptionalViewModel<T>
): T | undefined {
  return viewModel.present ? viewModel.value : undefined;
}

export function optionalNumberToViewModel(
  field: number | undefined,
  defaultValue: number = 0
): OptionalViewModel<number> {
  return optionalFieldToViewModel(field, defaultValue);
}
